<script>
import Vue from 'vue'
// resources
import EmployeeResource from '../../resources/employee'
import AssignmentResource from '../../resources/assignment'
// components&views
import EmployeeGrid from '../../components/EmployeeGrid.vue'
import AssignmentGrid from '../../components/AssignmentGrid.vue'
import assignmentHistoryGrid from '../../components/AssignmentHistoryGrid.vue'
import EditEmployee from '../edit_employee/EditEmployee.vue'
import EditAssignment from '../edit_assignment/EditAssignment.vue'
// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'

export default Vue.extend({
    data() {
        return {
            lastName: '',
            firstName: '',
            email: '',
            tin: '',
            employeeIteration: 0,
            assignmentIteration: 100,
            assignmentHistoryIteration: 1000,
            employeesRowData: [],
            assignmentRowData: [],
            assignmentHistoryRowData: [],
            selectedEmployeeResource: null,
            selectedAssignment: null,
        }
    },
    mixins: [toastMixin, modalMixin],
    components: {
        EmployeeGrid,
        AssignmentGrid,
        assignmentHistoryGrid,
        EditEmployee,
        EditAssignment,
    },
    computed: {
        resources() {
            return {
                EmployeeResource,
                AssignmentResource,
            }
        },
    },
    methods: {
        async getData() {
            let options = {}
            if (this.lastName) options.last_name__contains = this.lastName
            if (this.firstName) options.first_name__contains = this.firstName
            if (this.email) options.email__contains = this.email

            let employee = await this.resources.EmployeeResource.all(options)
            for (let result of employee) {
                await result.resolveRelated()
            }
            this.employeesRowData = employee
            this.employeeIteration++
        },

        selectEmployee(selectedResource) {
            if (selectedResource && selectedResource.id) this.selectedEmployeeResource = selectedResource
        },

        async onShowSelectedEmployeeAssignments() {
            let assignment = this.selectedEmployeeResource.wrap('/assignments')
            let employeeAssignments = await assignment.get({ params: { id: this.selectedEmployeeResource.id } })
            let { data } = employeeAssignments
            let assignmentResource = []
            for (let result of data.results) {
                let resource = await this.resources.AssignmentResource.detail(result.id)
                await resource.resolveRelated()
                assignmentResource.push(resource)
            }
            this.assignmentRowData = assignmentResource
        },

        async selectAssignment(selectedResource) {
            if (selectedResource && selectedResource.id) {
                let assginment = await this.resources.AssignmentResource.detail(selectedResource.id)
                this.selectedAssignment = assginment
            }
        },

        async onShowSelectedAssignmentHistory() {
            let assignment = this.selectedAssignment.wrap('/history')
            let assignmentsHistory = await assignment.get({ params: { id: this.selectedAssignment.id } })
            let { data } = assignmentsHistory
            this.assignmentHistoryRowData = data.results
        },
    },
})
</script>

<template>
    <div class="pageStyling">
        <b-row>
            <b-col cols="2">
                <p>Last Name</p>
                <input class="form-control" name="last_name" v-model="lastName" />
            </b-col>
            <b-col cols="2">
                <p>First Name</p>
                <input class="form-control" name="first_name" v-model="firstName" />
            </b-col>
            <b-col cols="2">
                <p>E-mail</p>
                <input class="form-control" name="email" v-model="email" />
            </b-col>
            <b-col>
                <b-button @click="getData">Search</b-button>
            </b-col>
        </b-row>
        <div v-if="selectedEmployeeResource" class="pageStyling">
            <div class="buttonContainer">
                <edit-employee :employeeResource="this.selectedEmployeeResource"></edit-employee>
                <b-button @click="onShowSelectedEmployeeAssignments">Show Selected Assignments</b-button>
                <div class="clear"></div>
            </div>
        </div>
        <employee-grid :row-data="employeesRowData" :key="employeeIteration" class="ag-theme-balham agGrid" @select="selectEmployee" />
        <div v-if="selectedAssignment" class="pageStyling">
            <div class="buttonContainer">
                <edit-assignment :assignmentResource="this.selectedAssignment"></edit-assignment>
                <b-button @click="onShowSelectedAssignmentHistory">Show Selected Assignment History</b-button>
                <div class="clear"></div>
            </div>
        </div>
        <assignment-grid v-if="this.assignmentRowData.length" :row-data="assignmentRowData" :key="assignmentIteration" class="ag-theme-balham agGrid" @select="selectAssignment" />
        <assignment-history-grid v-if="this.assignmentHistoryRowData.length" :row-data="assignmentHistoryRowData" :key="assignmentHistoryIteration" class="ag-theme-balham agGrid" />
    </div>
</template>

<style scoped>
.fake-link {
    text-decoration: underline;
    color: blue;
}

.pageStyling {
    margin: 50px 0px 0px 25px;
}

.autocompleteContainer {
    width: 25%;
}

.agGrid {
    margin: 50px 0px 0px 0px;
}

.buttonContainer {
    display: flex;
    margin-top: 20px;
}

.buttonContainer > * {
    margin-right: 20px;
}
</style>
